var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      attrs: { "has-border": false },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c("div", { staticClass: "edition-template-container" }, [
                _c(
                  "div",
                  { staticClass: "row-container" },
                  _vm._l(_vm.results, function(data, index) {
                    return _c(
                      "div",
                      {
                        key: `row-sample-info-${index}`,
                        staticClass: "rounded-bottom px-2 pt-2",
                        attrs: { asda: "" }
                      },
                      [
                        _vm.isEvaluationTherapySample
                          ? _c(
                              "div",
                              {
                                staticClass: "row mx-auto bg-white rounded p-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col font-weight-bold d-flex align-items-center"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(data.companyName)
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "vertical-divider" }, [
                                  _vm._v(" ")
                                ]),
                                _c("div", { staticClass: "col text-center" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 d-block font-14"
                                    },
                                    [_vm._v(" Lugares de Servicio ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-16 color-black" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(data.locationCount) + " "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "col text-center" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 d-block font-14"
                                    },
                                    [_vm._v(" Especialistas ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-16 color-black" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(data.specialistCount) + " "
                                      )
                                    ]
                                  )
                                ]),
                                _c("div", { staticClass: "col text-center" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 d-block font-14"
                                    },
                                    [
                                      _vm._v(
                                        " Muestra Seleccionada (Estudiantes) "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-16 color-black" },
                                    [
                                      _vm._v(
                                        " " + _vm._s(data.studentCount) + " "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm.isTransportationSample
                          ? _c(
                              "div",
                              {
                                staticClass: "row mx-auto bg-white rounded p-3"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-2 font-weight-bold d-flex align-items-center"
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("empty")(data.regionName)
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("div", { staticClass: "vertical-divider" }, [
                                  _vm._v(" ")
                                ]),
                                _c("div", { staticClass: "col pl-5" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 d-block font-14"
                                    },
                                    [_vm._v(" Conteo de cuestionarios: ")]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-16 color-black" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              data.questionnaireCount
                                            )
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  }),
                  0
                ),
                _c(
                  "div",
                  { staticClass: "pl-1 mx-auto" },
                  [
                    _vm.showPagination
                      ? _c("pagination", {
                          attrs: { data: _vm.pagination, "show-text": "" },
                          on: { "pagination-go-page": _vm.goToPageHandler }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _c("div", { staticClass: "p-2 mt-2" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-12 row mx-auto p-1 rounded text-center"
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-1 total-title bg-white font-weight-bold rounded-left p-4"
                        },
                        [_vm._v(" Total ")]
                      ),
                      _vm.isEvaluationTherapySample
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-center justify-content-center bg-money-green color-white"
                            },
                            [
                              _c("div", { staticClass: "col" }, [
                                _c("span", { staticClass: "d-block font-14" }, [
                                  _vm._v(" Lugares de Servicio ")
                                ]),
                                _c("span", { staticClass: "font-18" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.locationCounter
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.isEvaluationTherapySample
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-center justify-content-center bg-money-green color-white"
                            },
                            [
                              _c("div", { staticClass: "col" }, [
                                _c("span", { staticClass: "d-block font-14" }, [
                                  _vm._v(" Especialistas ")
                                ]),
                                _c("span", { staticClass: "font-18" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.specialistCounter
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.isEvaluationTherapySample
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-center justify-content-center bg-money-green color-white rounded-right"
                            },
                            [
                              _c("div", { staticClass: "col" }, [
                                _c("span", { staticClass: "d-block font-14" }, [
                                  _vm._v(
                                    " Muestra Seleccionada (" +
                                      _vm._s(_vm.individualType) +
                                      ") "
                                  )
                                ]),
                                _c("span", { staticClass: "font-18" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("formatNumber")(
                                          _vm.studentCounter
                                        )
                                      ) +
                                      " "
                                  )
                                ])
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm.isTransportationSample
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "col d-flex align-items-center bg-money-green color-white"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "col text-left offset-1" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "d-block font-14" },
                                    [_vm._v(" Total ")]
                                  ),
                                  _c("span", { staticClass: "font-18" }, [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.questionnaireCounter
                                          )
                                        ) +
                                        " "
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row mx-auto p-4 font-weight-bold" }, [
        _vm._v(" " + _vm._s(_vm.title) + " ")
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }